import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'

import { useRentRollRootStyles } from './styles'

interface RentRollAnalyzingProps {
    filename?: string | null
}

export const RentRollAnalyzing: React.FC<RentRollAnalyzingProps> = ({
    filename,
}) => {
    const classes = useRentRollRootStyles({
        headerHeight: 0,
        collapsableSelectorHeight: 0,
    })

    return (
        <Box className={classes.reviewPanel}>
            <Box className={classes.reviewCard}>
                <CircularProgress size={36} />
                <Typography variant="h6">
                    Analyzing your rent roll...
                </Typography>
                {filename && (
                    <Typography variant="body2" color="textSecondary">
                        {filename}
                    </Typography>
                )}
                <Typography
                    variant="body2"
                    color="textSecondary"
                    align="center"
                >
                    We are reading your file and identifying residents. This
                    usually takes less than a minute.
                </Typography>
            </Box>
        </Box>
    )
}
